/**
 * Copy of Data Vault › Product / Price Sync › Shopify
 * (`components/ProductPriceSync/ShopifySyncPanel.tsx`), from the Shopify part
 * of VentaHub's `pages/product_price_upload.tsx`: sync a store's products or
 * its orders for a date range, and follow what each sync read and loaded.
 */
export const shopifySync = {
  tabs: {
    label: 'Sync',
    prices: 'OTTO price upload',
    shopify: 'Shopify sync',
  },
  title: 'Sync from Shopify',
  description:
    'Read a Shopify store’s products or its orders into VentaWiz. Nothing is written to Shopify.',
  store: {
    label: 'Store',
    placeholder: 'Pick a Shopify store',
    empty: 'No Shopify store to sync',
    emptyHint: 'A store appears here once it is a Shopify store you have access to.',
  },
  kind: {
    label: 'What to sync',
    products: 'Products',
    orders: 'Orders',
  },
  range: {
    from: 'From',
    to: 'To',
    hint: 'Orders placed on these days (UTC). Leave both blank for the last 30 days.',
    backwards: 'The end date is before the start date.',
  },
  start: {
    products: 'Sync products',
    orders: 'Sync orders',
    starting: 'Starting…',
    started: 'Sync started. It appears below as soon as it is queued.',
    failed: 'The sync could not be started.',
    viewOnly: 'You can see this store’s syncs; starting one needs catalogue edit access.',
  },
  runs: {
    title: 'Recent syncs',
    empty: 'No {{kind}} sync for this store yet',
    emptyHint: 'Start one above; it shows here as soon as it is queued.',
    columns: {
      created: 'Started',
      status: 'Status',
      range: 'Orders from',
      read: 'Read',
      loaded: 'Loaded',
      rejected: 'Not used',
    },
    open: 'Open the sync of {{when}}',
    queued: 'Queued',
    allDays: 'Last 30 days',
    rangeOf: '{{from}} – {{to}}',
  },
  detail: {
    title: 'Sync of {{when}}',
    close: 'Close',
    counts: {
      pages: 'Pages read',
      rows: 'Rows read',
      rejected: 'Rows Shopify sent that could not be read',
      loaded: 'Rows loaded',
      notLoaded: 'Rows not loaded',
    },
    loading: 'Loading the rows into VentaWiz…',
    loadFailed: 'Loading failed: {{error}}',
    runFailed: 'The sync failed: {{error}}',
    parseRejects: 'Rows that could not be read',
    loadRejects: 'Rows not loaded',
    loadRejectsCapped: 'The first 200 are listed.',
    columns: {
      code: 'Problem',
      message: 'Detail',
      value: 'Value',
      entity: 'Table',
      reason: 'Reason',
      key: 'SKU or order',
    },
    none: 'Every row was read and loaded.',
  },
} as const
